
(() => {
  const pre = document.querySelector('[data-preloader]');
  window.addEventListener('load', () => { setTimeout(() => pre && pre.classList.add('hide'), 650); });
  const header = document.querySelector('[data-header]');
  const onScroll = () => header && header.classList.toggle('is-scrolled', scrollY > 30);
  onScroll(); window.addEventListener('scroll', onScroll, {passive:true});

  const menuBtn = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  menuBtn && menuBtn.addEventListener('click', () => { const isOpen = menu.classList.toggle('open'); menuBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false'); });
  menu && menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => { menu.classList.remove('open'); menuBtn && menuBtn.setAttribute('aria-expanded','false'); }));

  const drawer = document.querySelector('[data-cart-drawer]');
  const backdrop = document.querySelector('.drawer-backdrop');
  document.querySelectorAll('[data-cart-open]').forEach(b => b.addEventListener('click', () => { drawer && drawer.classList.add('open'); backdrop && backdrop.classList.add('open'); drawer && drawer.setAttribute('aria-hidden','false'); menu && menu.classList.remove('open'); menuBtn && menuBtn.setAttribute('aria-expanded','false'); }));
  const closeDrawer = () => { drawer && drawer.classList.remove('open'); backdrop && backdrop.classList.remove('open'); drawer && drawer.setAttribute('aria-hidden','true'); };
  document.querySelectorAll('[data-cart-close]').forEach(b => b.addEventListener('click', closeDrawer));
  backdrop && backdrop.addEventListener('click', closeDrawer);

  const io = new IntersectionObserver((entries) => entries.forEach(e => { if(e.isIntersecting){ e.target.classList.add('is-visible'); io.unobserve(e.target); } }), {threshold:.12});
  document.querySelectorAll('.reveal-up,.reveal-pop').forEach(el => io.observe(el));

  document.querySelectorAll('.scalia-tilt').forEach(card => {
    card.addEventListener('mousemove', e => {
      if (window.matchMedia('(max-width: 900px)').matches) return;
      const r = card.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - .5;
      const y = (e.clientY - r.top) / r.height - .5;
      card.style.transform = `perspective(900px) rotateX(${-y*8}deg) rotateY(${x*8}deg) translateY(-8px)`;
    });
    card.addEventListener('mouseleave', () => card.style.transform = '');
  });

  const stage = document.querySelector('[data-parallax]');
  if(stage){
    window.addEventListener('mousemove', e => {
      if (window.matchMedia('(max-width: 900px)').matches) return;
      const x = (e.clientX / innerWidth - .5) * 18;
      const y = (e.clientY / innerHeight - .5) * 18;
      stage.style.transform = `rotateY(${x/3}deg) rotateX(${-y/4}deg)`;
    }, {passive:true});
  }
})();
document.addEventListener("DOMContentLoaded", function () {
  const preloader = document.querySelector("[data-preloader]");
  const html = document.documentElement;

  if (!preloader) return;

  const alreadySeen = sessionStorage.getItem("scaliaPreloaderSeen");

  if (alreadySeen === "true") {
    preloader.remove();
    html.classList.remove("scalia-preloader-active");
    return;
  }

  sessionStorage.setItem("scaliaPreloaderSeen", "true");

  const hidePreloader = () => {
    preloader.classList.add("is-hidden");
    html.classList.remove("scalia-preloader-active");

    setTimeout(() => {
      preloader.remove();
    }, 800);
  };

  window.addEventListener("load", function () {
    setTimeout(hidePreloader, 1700);
  });

  setTimeout(hidePreloader, 4200);
});
/* ==============================
   COLLECTION MOBILE FILTER DRAWER
============================== */

(function () {
  function openScaliaFilters() {
    const sidebar = document.querySelector("[data-filter-sidebar]");
    const overlay = document.querySelector("[data-filter-overlay]");

    if (!sidebar || !overlay) return;

    sidebar.classList.add("open");
    overlay.classList.add("open");
    document.body.classList.add("filters-open");
  }

  function closeScaliaFilters() {
    const sidebar = document.querySelector("[data-filter-sidebar]");
    const overlay = document.querySelector("[data-filter-overlay]");

    if (!sidebar || !overlay) return;

    sidebar.classList.remove("open");
    overlay.classList.remove("open");
    document.body.classList.remove("filters-open");
  }

  document.addEventListener("click", function (event) {
    const openBtn = event.target.closest("[data-filter-toggle]");
    const closeBtn = event.target.closest("[data-filter-close]");
    const overlay = event.target.closest("[data-filter-overlay]");

    if (openBtn) {
      event.preventDefault();
      openScaliaFilters();
    }

    if (closeBtn || overlay) {
      event.preventDefault();
      closeScaliaFilters();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeScaliaFilters();
    }
  });

  document.addEventListener("shopify:section:load", function () {
    closeScaliaFilters();
  });
})();
/* ==============================
   CAFFÈ SCALIA - AJAX QUICK ADD
   Aggiunge al carrello senza aprire il drawer
============================== */

(function () {
  function getCartButton() {
    return (
      document.querySelector("[data-cart-open]") ||
      document.querySelector(".cart-toggle")
    );
  }

  function updateCartCount(count) {
    const counters = document.querySelectorAll("[data-cart-count], .cart-count, .cart-toggle span");

    counters.forEach((counter) => {
      counter.textContent = count;
      counter.style.display = count > 0 ? "inline-flex" : "none";
    });
  }

  function animateToCart(form) {
    const cartButton = getCartButton();
    if (!cartButton) return;

    const image =
      form.closest(".product-card")?.querySelector(".product-card-image") ||
      form.closest(".product-card")?.querySelector(".fake-pack");

    const startElement = image || form.querySelector("[data-quick-add-btn]");
    if (!startElement) return;

    const start = startElement.getBoundingClientRect();
    const end = cartButton.getBoundingClientRect();

    const flyer = document.createElement("div");
    flyer.className = "scalia-cart-flyer";

    if (image && image.tagName === "IMG") {
      const clonedImage = image.cloneNode(true);
      flyer.appendChild(clonedImage);
    } else {
      flyer.innerHTML = "☕";
    }

    flyer.style.left = `${start.left + start.width / 2}px`;
    flyer.style.top = `${start.top + start.height / 2}px`;

    document.body.appendChild(flyer);

    const moveX = end.left + end.width / 2 - (start.left + start.width / 2);
    const moveY = end.top + end.height / 2 - (start.top + start.height / 2);

    requestAnimationFrame(() => {
      flyer.style.transform = `translate(${moveX}px, ${moveY}px) scale(.18) rotate(18deg)`;
      flyer.style.opacity = "0";
    });

    setTimeout(() => {
      flyer.remove();
      cartButton.classList.add("cart-added-bump");

      setTimeout(() => {
        cartButton.classList.remove("cart-added-bump");
      }, 450);
    }, 850);
  }

  async function getCartData() {
    const response = await fetch("/cart.js", {
      headers: {
        Accept: "application/json"
      }
    });

    if (!response.ok) {
      throw new Error("Impossibile leggere il carrello");
    }

    return response.json();
  }

  async function refreshCartDrawer() {
    const currentDrawer = document.querySelector("[data-cart-drawer]");
    if (!currentDrawer) return;

    try {
      const response = await fetch("/cart?section_id=cart-drawer-scalia-ultra", {
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      });

      if (!response.ok) return;

      const html = await response.text();
      const temp = document.createElement("div");
      temp.innerHTML = html;

      const newDrawer = temp.querySelector("[data-cart-drawer]");

      if (newDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
        currentDrawer.setAttribute("aria-hidden", "true");
        currentDrawer.classList.remove("open");
      }

      const backdrop = document.querySelector(".drawer-backdrop");
      if (backdrop) {
        backdrop.classList.remove("open");
      }
    } catch (error) {
      console.warn("Caffè Scalia: aggiornamento drawer non riuscito", error);
    }
  }

  async function handleQuickAdd(form) {
    const button = form.querySelector("[data-quick-add-btn]");
    if (!button || button.disabled) return;

    const originalText = button.textContent.trim();

    button.disabled = true;
    button.textContent = "Aggiungo...";
    button.classList.remove("is-added", "is-error");

    try {
      const formData = new FormData(form);

      const response = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json"
        }
      });

      if (!response.ok) {
        throw new Error("Prodotto non aggiunto");
      }

      animateToCart(form);

      const cart = await getCartData();
      updateCartCount(cart.item_count);

      refreshCartDrawer();

      button.textContent = "Aggiunto ✓";
      button.classList.add("is-added");

      setTimeout(() => {
        button.textContent = originalText;
        button.classList.remove("is-added");
        button.disabled = false;
      }, 1300);
    } catch (error) {
      button.textContent = "Errore";
      button.classList.add("is-error");

      setTimeout(() => {
        button.textContent = originalText;
        button.classList.remove("is-error");
        button.disabled = false;
      }, 1500);
    }
  }

  document.addEventListener("submit", function (event) {
    const form = event.target.closest("[data-quick-add-form]");
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();

    handleQuickAdd(form);
  });
})();
/* ==============================
   CAFFÈ SCALIA - BESTSELLER BLAST 3D
============================== */

(function () {
  function initScaliaBlast() {
    const sections = document.querySelectorAll("[data-scalia-blast]");

    sections.forEach((section) => {
      if (section.dataset.scaliaBlastReady === "true") return;
      section.dataset.scaliaBlastReady = "true";

      const track = section.querySelector("[data-blast-track]");
      const prev = section.querySelector("[data-blast-prev]");
      const next = section.querySelector("[data-blast-next]");
      const dotsWrap = section.querySelector("[data-blast-dots]");
      const cards = Array.from(track ? track.querySelectorAll(".product-card") : []);

      if (!track || !cards.length) return;

      let active = 0;
      let timer = null;
      let startX = 0;

      function isMobile() {
        return window.matchMedia("(max-width: 990px)").matches;
      }

      function getOffset(index) {
        let offset = index - active;
        const half = Math.floor(cards.length / 2);

        if (offset > half) offset -= cards.length;
        if (offset < -half) offset += cards.length;

        return offset;
      }

      function getTransform(offset) {
        const abs = Math.abs(offset);
        const mobile = isMobile();

        if (abs > 2) {
          return {
            transform: "translate(-50%, -50%) scale(.35) translateZ(-420px)",
            opacity: "0",
            blur: "4px",
            z: "1"
          };
        }

        if (mobile) {
          if (offset === 0) {
            return {
              transform: "translate(-50%, -50%) translateX(0px) translateZ(100px) rotateY(0deg) scale(1)",
              opacity: "1",
              blur: "0px",
              z: "30"
            };
          }

          return {
            transform: `translate(-50%, -50%) translateX(${offset * 190}px) translateZ(${-abs * 150}px) rotateY(${offset * -32}deg) scale(${1 - abs * 0.16})`,
            opacity: abs === 1 ? ".46" : "0",
            blur: abs === 1 ? "1.2px" : "4px",
            z: String(20 - abs)
          };
        }

        if (offset === 0) {
          return {
            transform: "translate(-50%, -50%) translateX(0px) translateZ(180px) rotateY(0deg) scale(1.08)",
            opacity: "1",
            blur: "0px",
            z: "40"
          };
        }

        if (offset === -1) {
          return {
            transform: "translate(-50%, -50%) translateX(-430px) translateZ(-130px) rotateY(36deg) scale(.76)",
            opacity: ".62",
            blur: "1px",
            z: "20"
          };
        }

        if (offset === 1) {
          return {
            transform: "translate(-50%, -50%) translateX(430px) translateZ(-130px) rotateY(-36deg) scale(.76)",
            opacity: ".62",
            blur: "1px",
            z: "20"
          };
        }

        if (offset === -2) {
          return {
            transform: "translate(-50%, -50%) translateX(-720px) translateZ(-300px) rotateY(48deg) scale(.52)",
            opacity: ".20",
            blur: "2px",
            z: "8"
          };
        }

        return {
          transform: "translate(-50%, -50%) translateX(720px) translateZ(-300px) rotateY(-48deg) scale(.52)",
          opacity: ".20",
          blur: "2px",
          z: "8"
        };
      }

      function render() {
        cards.forEach((card, index) => {
          const offset = getOffset(index);
          const abs = Math.abs(offset);
          const state = getTransform(offset);

          card.style.setProperty("--blast-transform", state.transform);
          card.style.setProperty("--blast-opacity", state.opacity);
          card.style.setProperty("--blast-blur", state.blur);
          card.style.setProperty("--blast-z", state.z);

          card.classList.toggle("is-active", offset === 0);
          card.classList.toggle("is-near", abs === 1);
          card.classList.toggle("is-far", abs > 1);
        });

        const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll("button")) : [];

        dots.forEach((dot, index) => {
          dot.classList.toggle("is-active", index === active);
        });
      }

      function goNext() {
        active = (active + 1) % cards.length;
        render();
      }

      function goPrev() {
        active = (active - 1 + cards.length) % cards.length;
        render();
      }

      function startAuto() {
        stopAuto();
        timer = setInterval(goNext, 3200);
      }

      function stopAuto() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      if (dotsWrap) {
        dotsWrap.innerHTML = "";

        cards.forEach((_, index) => {
          const dot = document.createElement("button");
          dot.type = "button";
          dot.setAttribute("aria-label", `Vai al prodotto ${index + 1}`);

          dot.addEventListener("click", () => {
            active = index;
            render();
            startAuto();
          });

          dotsWrap.appendChild(dot);
        });
      }

      if (next) {
        next.addEventListener("click", () => {
          goNext();
          startAuto();
        });
      }

      if (prev) {
        prev.addEventListener("click", () => {
          goPrev();
          startAuto();
        });
      }

      cards.forEach((card, index) => {
        card.addEventListener("click", (event) => {
          const offset = getOffset(index);

          if (offset !== 0 && !event.target.closest("button, a, input, form")) {
            event.preventDefault();
            active = index;
            render();
            startAuto();
          }
        });
      });

      section.addEventListener("mouseenter", stopAuto);
      section.addEventListener("mouseleave", startAuto);

      track.addEventListener(
        "touchstart",
        (event) => {
          startX = event.touches[0].clientX;
          stopAuto();
        },
        { passive: true }
      );

      track.addEventListener(
        "touchend",
        (event) => {
          const endX = event.changedTouches[0].clientX;
          const diff = startX - endX;

          if (Math.abs(diff) > 45) {
            diff > 0 ? goNext() : goPrev();
          }

          startAuto();
        },
        { passive: true }
      );

      window.addEventListener("resize", render);

      render();
      startAuto();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initScaliaBlast);
  } else {
    initScaliaBlast();
  }

  document.addEventListener("shopify:section:load", initScaliaBlast);
})();